export default __webpack_public_path__ + "static/media/s4.c8ab249d.jpg";